import React,{useEffect,useState} from 'react';
import {motion} from 'framer-motion';

const EventBanner=()=> {
  const [isVisible,setIsVisible]=useState(false);

  useEffect(()=> {
    const now=new Date();
    const expiryDate=new Date('2026-10-07T00:00:00');
    setIsVisible(now < expiryDate);
  },[]);

  if (!isVisible) return null;

  return (
    <motion.section
      initial={{opacity: 0,y: -20}}
      animate={{opacity: 1,y: 0}}
      transition={{duration: 0.6}}
      className="w-full px-4 py-4 text-center"
      style={{
        backgroundColor: '#314C40',
        color: '#F9F5F0',
        fontFamily: 'Lato,sans-serif'
      }}
    >
      <div aria-hidden="true" className="leading-relaxed">
        <br />
        <br />
      </div>

      <div className="flex flex-col items-center justify-center">
        <p style={{fontSize: '16px',fontWeight: 700,lineHeight: 1.5}}>
          Wir sind auf der Herbst-Ausstellung – Themenwochenende Gesundheit &amp; Beauty-Days
        </p>
        <p style={{fontSize: '13px',fontWeight: 400,lineHeight: 1.5}}>
          3. &amp; 4. Oktober · Halle 5, Stand 555
        </p>
        <p style={{fontSize: '14px',fontWeight: 400,lineHeight: 1.5}}>
          Exklusive Termine für Kurs &amp; Retreat – inklusive Klangreise bei Marcella
        </p>
      </div>
    </motion.section>
  );
};

export default EventBanner;